<template src="./Autorizar.html"></template>
<style scoped src="./Autorizar.css"></style>

<script>
import { autorizaNegaAcessoRealtec } from "@/services/modules/acessoRealtec.js";
import store from "@/store/index.js";

const AUTORIZAR = 1;
const NEGAR = 2;

export default {
  props: {
    acesso: {
      type: Object
    },
    closeDialog: {
      type: Function
    }
  },
  data() {
    return {
      valid: false,
      observacao: '',
      observacaoRules: [
        v => !!v || "Campo obrigatório.",
        v => v.length >= 15 || "Observação deve contém no mínimo 15 caracteres."
      ]
    };
  },
  methods: {
    autorizar() {
      autorizaNegaAcessoRealtec(
        this.acesso.ACREALCONTADOR,
        AUTORIZAR,
        this.observacao,
        this.user.USUCODIGO
      );

      this.observacao = "";
      this.$refs.form.reset()
      this.closeDialog();
    },
    negar() {
      if (this.$refs.form.validate()) {
        autorizaNegaAcessoRealtec(
          this.acesso.ACREALCONTADOR,
          NEGAR,
          this.observacao,
          this.user.USUCODIGO
        );

        this.observacao = "";
        this.$refs.form.reset()
        this.closeDialog();
      }
    },
    close(){
      this.$refs.form.reset()
      this.closeDialog();
    }
  },
  computed: {
    user(){      
      return store.state.user.data
    },
  }
};
</script>